const cache = new Map();

const apiCache = {
  get(key) {
    return cache.has(key) ? cache.get(key) : null;
  },
  set(key, value) {
    cache.set(key, value);
  },
  invalidate(key) {
    cache.delete(key);
  },
  clear() {
    cache.clear();
  },
};

export default apiCache;
